module.exports = __webpack_public_path__ + "img/1.edc1f6ab.jpg";